const module = { name: 'news/article/app', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { default as disqus } from 'swug-fdRequire-call:shared/global/disqus';

function run() {
    checkDependencies(module.name, debugLog);
    disqus.init();
}
run();
export default module.exports;